// extracted by mini-css-extract-plugin
export var copied__tooltip = "hero-module--copied__tooltip--1d2ea";
export var fadeOut = "hero-module--fade-out--d204c";
export var hero = "hero-module--hero--00c07";
export var hero__introduction = "hero-module--hero__introduction--6f442";
export var hero__meta = "hero-module--hero__meta--f2307";
export var hero__meta__left = "hero-module--hero__meta__left--9e8b7";
export var hero__meta__left__links = "hero-module--hero__meta__left__links--29d1c";
export var hero__meta__left__links__link = "hero-module--hero__meta__left__links__link--c3fef";
export var hero__meta__right = "hero-module--hero__meta__right--9bfb8";